import React from "react";
import "./WelcomeScreen.css";
function WelcomeScreen({ setQuestionsReady, totalQuestions }) {
  const year = new Date().getFullYear();
  return (
    <div className="startscreen">
      <h1> Welcome to The React Quiz!</h1>
      <h3>{totalQuestions} questions to test your React Skill</h3>
      <button onClick={() => setQuestionsReady(true)} className="start">
        Start Now
      </button>

      <p className="">
        <span> © {year} built by </span>
        <a
          href="https://mounadaas.netlify.app"
          target="blank"
          className="text-slate-400"
        >
          Daas Mouna
        </a>
      </p>
    </div>
  );
}

export default WelcomeScreen;
